import FlagOutlinedIcon from "@material-ui/icons/FlagOutlined";

export const LanguageSelector = ({
  currentLanguage,
  possibleLanguages,
  setNewLanguage,
}) => {
  return (
    <div className="dropdown">
      <FlagOutlinedIcon className="dropdown-language-image" />
      <span className="dropdown-language-text">
        {currentLanguage.toUpperCase()}
      </span>
      <div className="dropdown-content">
        {possibleLanguages
          .filter((language) => language !== currentLanguage)
          .map((possibleLanguage, index) => (
            <a onClick={() => setNewLanguage(possibleLanguage)} key={index}>
              {possibleLanguage.toUpperCase()}
            </a>
          ))}
      </div>
    </div>
  );
};
